export default "__VITE_ASSET__CdcBkHrd__"